const SectionShapes = document.querySelectorAll(".section-shape");
if (SectionShapes.length) {
  SectionShapes.forEach((shape) => {
    const shapeHeight = shape.offsetHeight;
    const section = shape.closest('.shopify-section');
    if (section) {
      section.style.setProperty('--height', shapeHeight + 'px');
    }
  });
}

// Section wice ek Faq open js
const TabBlocks = document.querySelectorAll(".shopify-section");
if (TabBlocks.length) {
  TabBlocks.forEach(block => {
    const summaries = block.querySelectorAll('[id^="Details-"] summary');

    summaries.forEach(summary => {
      summary.addEventListener('click', function () {
        const allDetails = block.querySelectorAll('[id^="Details-"]');

        allDetails.forEach(detail => {
          if (detail !== this.parentElement) {
            detail.removeAttribute('open');
          }
        });
      });
    });
  });
}

const VideoPlayButtons = document.querySelectorAll(".video-poster");

VideoPlayButtons.forEach((PlayButton) => {
  PlayButton.addEventListener('click', function () {
    this.classList.add('video_played');
    const video = this.nextElementSibling;
    if (video && video.tagName.toLowerCase() === 'video') {
      video.play();
      video.addEventListener('click', function handleVideoClick() {
        video.pause();
        PlayButton.classList.remove('video_played');
        video.removeEventListener('click', handleVideoClick);
      });
    }
  });
});

